'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _userSmall = require('../../assets/images/user-small.png');

var _userSmall2 = _interopRequireDefault(_userSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserItem(_ref) {
  var destroy = _ref.destroy,
      openModal = _ref.openModal,
      selectedType = _ref.selectedType,
      uninvite = _ref.uninvite,
      user = _ref.user,
      currentUser = _ref.currentUser;

  var row = _react2.default.createElement(
    'div',
    { className: 'row' },
    _react2.default.createElement(
      'div',
      { className: 'col-md-1 result-img' },
      _react2.default.createElement('img', { src: user.avatar && user.avatar.sizes.small || _userSmall2.default, width: '48', height: '48', alt: '' })
    ),
    _react2.default.createElement(
      'div',
      { className: (currentUser.role === 'super_admin ' ? 'col-md-6' : 'col-md-7') + ' result-info' },
      _react2.default.createElement(
        'h3',
        null,
        user.name
      ),
      _react2.default.createElement(
        'span',
        null,
        user.email
      )
    )
  );

  return _react2.default.createElement(
    'div',
    { className: 'row-fluid result' },
    currentUser.role === 'super_admin' && _react2.default.createElement(
      'a',
      {
        className: 'col-md-11',
        onClick: openModal.bind(this, user)
      },
      row
    ),
    currentUser.role !== 'super_admin' && _react2.default.createElement(
      'span',
      { className: 'col-md-11' },
      row
    ),
    !selectedType && currentUser.role === 'super_admin' && _react2.default.createElement('a', {
      className: 'col-md-1 result-delete',
      href: '#',
      onClick: destroy.bind(this, user.id)
    }),
    selectedType && _react2.default.createElement('a', {
      className: 'col-md-1 result-unlink',
      href: '#',
      onClick: uninvite.bind(this, user.id)
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/User/UserItem.js
// module id = 2251
// module chunks = 0